import { useCallback } from 'react';
import type { issueCreateMutation_useIssueCreateMutation$data as CreateIssueMutationResponse } from '@atlassian/jira-relay/src/__generated__/issueCreateMutation_useIssueCreateMutation.graphql';
import type { GroupContextField } from '../types.tsx';

export type HasIssueCreateFieldChanged = (
	groupContextField: GroupContextField,
	createdIssue?: CreateIssueMutationResponse | null,
) => boolean;

const getCreatedIssueFieldValue = (createdIssue: CreateIssueMutationResponse, fieldId: string) => {
	const issueField = createdIssue.jira?.createIssue?.issue?.fieldsByIdOrAlias?.find(
		(field) => field?.fieldId === fieldId,
	);

	switch (issueField?.__typename) {
		case 'JiraStatusField':
			return issueField.status?.statusId;
		case 'JiraPriorityField':
			return issueField.priority?.priorityId;
		case 'JiraSingleSelectUserPickerField':
			return issueField.user?.accountId;
		case 'JiraSingleSelectField':
			return issueField.fieldOption?.optionId;
		case 'JiraSprintField':
			return issueField.sprints?.edges?.[0]?.node?.sprintId;
		case 'JiraNumberField':
			return issueField.number?.toString();
		default:
			return null;
	}
};

export const useHasIssueCreateFieldChanged = (): HasIssueCreateFieldChanged => {
	return useCallback(
		(groupContextField: GroupContextField, createdIssue?: CreateIssueMutationResponse | null) => {
			if (!createdIssue || !groupContextField) {
				return false;
			}

			const actualValue = getCreatedIssueFieldValue(createdIssue, groupContextField.fieldId);

			if (actualValue !== groupContextField.fieldValue) {
				// TODO: Add Flag
				return true;
			}

			return false;
		},
		[],
	);
};
